(function() {
  if (window.__influencerVideoCarouselLoaded) {
    return;
  }

  window.__influencerVideoCarouselLoaded = true;

  var desktopQuery = window.matchMedia('(min-width: 990px)');

  function scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  function scrollTrack(track, direction) {
    track.scrollBy({ left: direction * cardStep(track), behavior: scrollBehavior() });
  }

  function cardStep(track) {
    var card = track.querySelector('[data-influencer-carousel-card]');
    if (!card) {
      return track.clientWidth;
    }

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;

    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows(root) {
    var track = root.querySelector('[data-influencer-carousel-track]');
    var prev = root.querySelector('[data-influencer-carousel-prev]');
    var next = root.querySelector('[data-influencer-carousel-next]');

    if (!track || !prev || !next) {
      return;
    }

    var maxScroll = track.scrollWidth - track.clientWidth;
    var cardCount = track.querySelectorAll('[data-influencer-carousel-card]').length;
    var overflows = desktopQuery.matches && cardCount > 4 && maxScroll > 2;

    prev.hidden = !overflows;
    next.hidden = !overflows;

    if (!overflows) {
      return;
    }

    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll - 2;
  }

  function initCarousel(root) {
    if (root.getAttribute('data-influencer-carousel-ready') === 'true') {
      return;
    }

    var track = root.querySelector('[data-influencer-carousel-track]');
    if (!track) {
      return;
    }

    root.setAttribute('data-influencer-carousel-ready', 'true');
    bindVideoControls(root);
    playFirstVideo(root);

    var prev = root.querySelector('[data-influencer-carousel-prev]');
    var next = root.querySelector('[data-influencer-carousel-next]');

    if (!desktopQuery.matches) {
      var currentCard = visibleCard(track);
      if (currentCard) {
        currentCard.setAttribute('data-influencer-visible', 'true');
      }
    }

    track.addEventListener('scroll', function() {
      updateArrows(root);
      playVisibleVideo(root);
    }, { passive: true });

    track.addEventListener('keydown', function(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        return;
      }

      event.preventDefault();
      scrollTrack(track, event.key === 'ArrowRight' ? 1 : -1);
    });

    [
      [prev, -1],
      [next, 1]
    ].forEach(function(control) {
      if (!control[0]) {
        return;
      }

      control[0].addEventListener('click', function() {
        scrollTrack(track, control[1]);
      });
    });

    root.querySelectorAll('[data-influencer-carousel-card]').forEach(function(card) {
      var button = card.querySelector('[data-influencer-shop-look]');
      var media = card.querySelector('.influencer-carousel__media');
      if (!button || !media) {
        return;
      }

      media.addEventListener('pointerdown', function() {
        prepareShopTheLook(button);
      }, { once: true });

      media.addEventListener('click', function(event) {
        if (event.target.closest('[data-influencer-play], [data-influencer-mute]')) {
          return;
        }

        openShopTheLook(button);
      });
    });

    updateArrows(root);
  }

  function slugifyColor(value) {
    if (typeof value !== 'string') {
      return '';
    }

    var normalized = value.trim();
    if (!normalized) {
      return '';
    }

    if (typeof window.normalizeQuickshopSlug === 'function') {
      return window.normalizeQuickshopSlug(normalized);
    }

    return normalized
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function numericId(value) {
    if (value == null || value === '') {
      return null;
    }

    var text = String(value);
    var part = text.indexOf('/') === -1 ? text : text.split('/').pop();
    return part || null;
  }

  function variantHandle(variant, handles) {
    if (!variant) {
      return null;
    }

    if (variant.handle) {
      return variant.handle;
    }

    if (variant.product && variant.product.handle) {
      return variant.product.handle;
    }

    var productId = variantProductId(variant);
    return productId && handles ? handles[productId] : null;
  }

  function variantProductId(variant) {
    if (!variant) {
      return null;
    }

    if (variant.product && variant.product.id) {
      return numericId(variant.product.id);
    }

    if (variant.product_id) {
      return numericId(variant.product_id);
    }

    if (variant.featured_image && variant.featured_image.product_id) {
      return numericId(variant.featured_image.product_id);
    }

    return null;
  }

  function variantImage(variant) {
    if (!variant) {
      return null;
    }

    if (typeof variant.image === 'string' && variant.image) {
      return { src: variant.image, product_id: variantProductId(variant) };
    }

    var image = variant.featured_image;
    if (!image) {
      return null;
    }

    if (typeof image === 'string') {
      return { src: image };
    }

    return {
      src: image.src || image.url || '',
      product_id: variantProductId(variant)
    };
  }

  function storefrontToken() {
    if (typeof getStorefrontAccessToken === 'function') {
      return getStorefrontAccessToken();
    }

    var config = window.zsConfig || {};
    return typeof config.storefrontAccessToken === 'string' ? config.storefrontAccessToken : '';
  }

  function ensureShopLookHandles(variants) {
    var state = window.shopTheLookPopUpState || {};
    window.shopTheLookPopUpState = state;
    state.handlesByProductId = state.handlesByProductId || {};
    var handles = state.handlesByProductId;
    var missing = [];

    variants.forEach(function(variant) {
      var productId = variantProductId(variant);
      var handle = variantHandle(variant);
      if (productId && handle) {
        handles[productId] = handle;
        return;
      }

      if (productId && !handles[productId] && missing.indexOf(productId) === -1) {
        missing.push(productId);
      }
    });

    if (!missing.length) {
      return Promise.resolve(handles);
    }

    var token = storefrontToken();
    if (!token) {
      return Promise.resolve(handles);
    }

    return fetch(window.location.origin + '/api/2025-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({
        query: 'query getHandles($ids: [ID!]!) { nodes(ids: $ids) { ... on Product { id handle } } }',
        variables: {
          ids: missing.map(function(id) {
            return 'gid://shopify/Product/' + id;
          })
        }
      })
    }).then(function(response) {
      return response.json();
    }).then(function(json) {
      var nodes = json && json.data && Array.isArray(json.data.nodes) ? json.data.nodes : [];
      nodes.forEach(function(node) {
        if (!node || !node.id || !node.handle) {
          return;
        }

        var id = numericId(node.id);
        if (id) {
          handles[id] = node.handle;
        }
      });
      return handles;
    }).catch(function() {
      return handles;
    });
  }

  function readShopLookPayload(button) {
    if (button._shopLookPayload) {
      return button._shopLookPayload;
    }

    var key = button.getAttribute('data-influencer-shop-look');
    var node = key ? document.querySelector('[data-influencer-shop-look-data="' + key + '"]') : null;
    if (!node) {
      return null;
    }

    try {
      button._shopLookPayload = JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }

    return button._shopLookPayload;
  }

  function parseVariantIds(value) {
    var source = Array.isArray(value) ? value.join(',') : value;
    if (typeof source !== 'string' || !source) {
      return [];
    }

    var seen = {};
    var ids = [];

    source.split(/[\s,]+/).forEach(function(part) {
      var id = numericId(part);
      if (!id || !/^\d+$/.test(id) || seen[id]) {
        return;
      }

      seen[id] = true;
      ids.push(id);
    });

    return ids;
  }

  function shopLookThumb(url) {
    if (!url) {
      return null;
    }

    if (url.indexOf('width=') !== -1) {
      return url;
    }

    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }

  function fetchShopLookVariants(ids) {
    var token = storefrontToken();
    if (!token || !ids.length) {
      return Promise.resolve([]);
    }

    return fetch(window.location.origin + '/api/2025-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({
        query: 'query getShopLookVariants($ids: [ID!]!) { nodes(ids: $ids) { ... on ProductVariant { id title selectedOptions { name value } image { url } product { id handle featuredImage { url } } } } }',
        variables: {
          ids: ids.map(function(id) {
            return 'gid://shopify/ProductVariant/' + id;
          })
        }
      })
    }).then(function(response) {
      return response.json();
    }).then(function(json) {
      var nodes = json && json.data && Array.isArray(json.data.nodes) ? json.data.nodes : [];
      var byId = {};

      nodes.forEach(function(node) {
        if (!node || !node.id || !node.product || !node.product.handle) {
          return;
        }

        var id = numericId(node.id);
        if (!id) {
          return;
        }

        var colorName = '';
        var sizeName = '';
        (node.selectedOptions || []).forEach(function(option) {
          var name = String(option.name || '').toLowerCase();
          if (!colorName && (name === 'color' || name === 'colour')) {
            colorName = option.value || '';
          }
          if (!sizeName && name === 'size') {
            sizeName = option.value || '';
          }
        });

        if (!colorName && node.selectedOptions && node.selectedOptions[0]) {
          colorName = node.selectedOptions[0].value || '';
        }

        var imageUrl = (node.image && node.image.url) || (node.product.featuredImage && node.product.featuredImage.url) || '';
        byId[id] = {
          id: id,
          title: node.title || null,
          option1: colorName,
          sizeName: sizeName,
          product_id: numericId(node.product.id),
          handle: node.product.handle,
          image: shopLookThumb(imageUrl)
        };
      });

      return ids.map(function(id) {
        return byId[id];
      }).filter(Boolean);
    }).catch(function() {
      return [];
    });
  }

  function prepareShopTheLook(button) {
    if (button._shopLookReady) {
      return button._shopLookReady;
    }

    var payload = readShopLookPayload(button);
    var variantIds = parseVariantIds(payload && payload.variantIds);
    if (!payload || !variantIds.length || typeof showModalWindow !== 'function' || !window.jQuery) {
      return null;
    }

    button._shopLookReady = fetchShopLookVariants(variantIds).then(function(variants) {
      return ensureShopLookHandles(variants).then(function(handles) {
        var variantMeta = variants.map(function(variant) {
          var productId = variantProductId(variant);
          var colorName = variant.option1 || (Array.isArray(variant.options) ? variant.options[0] : '') || '';
          var handle = variantHandle(variant, handles);

          return {
            id: numericId(variant.id),
            title: variant.title || null,
            productId: productId,
            productHandle: handle || null,
            image: variantImage(variant),
          colorName: colorName,
          colorSlug: slugifyColor(colorName),
          sizeName: variant.sizeName || '',
          sizeSlug: slugifyColor(variant.sizeName || '')
          };
        }).filter(function(meta) {
          return meta.productHandle;
        });

        var primaryHandle = variantMeta.length ? variantMeta[0].productHandle : null;
        if (!primaryHandle) {
          return null;
        }

        return {
          handles: handles,
          variantMeta: variantMeta,
          primaryHandle: primaryHandle,
          activeColorName: (variantMeta[0] && variantMeta[0].colorName) || null,
          activeColorSlug: (variantMeta[0] && variantMeta[0].colorSlug) || ''
        };
      });
    });

    return button._shopLookReady;
  }

  var shopLookOpenRequest = 0;

  function openShopTheLook(button) {
    var requestId = ++shopLookOpenRequest;
    var ready = prepareShopTheLook(button);
    if (!ready) {
      return;
    }

    ready.then(function(prepared) {
      if (!prepared || requestId !== shopLookOpenRequest) {
        return;
      }

      var state = window.shopTheLookPopUpState || {};
      window.shopTheLookPopUpState = state;
      state.handlesByProductId = prepared.handles;
      state.carouselLook = {
        variantMeta: prepared.variantMeta,
        activeVariantId: prepared.variantMeta[0] ? prepared.variantMeta[0].id : null
      };
      window.shopTheLookPopUp = true;

      button.setAttribute('data-product-handle', prepared.primaryHandle);
      if (prepared.activeColorSlug) {
        button.setAttribute('data-color-slug', prepared.activeColorSlug);
      }
      if (prepared.variantMeta[0] && prepared.variantMeta[0].id) {
        button.setAttribute('data-variant-id', prepared.variantMeta[0].id);
      }

      showModalWindow(window.jQuery(button));
    });
  }

  function pauseOtherVideos(root, current) {
    root.querySelectorAll('video').forEach(function(other) {
      if (other !== current && !other.paused) {
        other.pause();
      }
    });
  }

  function assignSource(video) {
    if (video.getAttribute('src')) {
      return;
    }

    var source = video.getAttribute('data-src');
    if (source) {
      video.src = source;
    }
  }

  function removePoster(video) {
    var cover = video.parentElement.querySelector('.influencer-carousel__poster');
    if (cover) {
      cover.remove();
    }
  }

  function visibleCard(track) {
    var cards = track.querySelectorAll('[data-influencer-carousel-card]');
    var trackLeft = track.getBoundingClientRect().left;
    var best = null;
    var bestOffset = Infinity;

    cards.forEach(function(card) {
      var offset = Math.abs(card.getBoundingClientRect().left - trackLeft);
      if (offset < bestOffset) {
        bestOffset = offset;
        best = card;
      }
    });

    return best;
  }

  function playVisibleVideo(root) {
    var track = root.querySelector('[data-influencer-carousel-track]');
    if (!track) {
      return;
    }

    if (desktopQuery.matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var card = visibleCard(track);
    if (!card || card.getAttribute('data-influencer-visible') === 'true') {
      return;
    }

    track.querySelectorAll('[data-influencer-visible]').forEach(function(item) {
      item.removeAttribute('data-influencer-visible');
    });
    card.setAttribute('data-influencer-visible', 'true');
    root.setAttribute('data-influencer-handed-off', 'true');

    var video = card.querySelector('video');
    if (!video) {
      pauseOtherVideos(root, null);
      return;
    }

    assignSource(video);
    video.loop = true;
    removePoster(video);
    pauseOtherVideos(root, video);

    if (video.paused) {
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function() {});
      }
    }
  }

  function playFirstVideo(root) {
    var video = root.querySelector('[data-influencer-first-video]');
    if (!video || video.getAttribute('data-influencer-autostart') === 'true') {
      return;
    }

    video.setAttribute('data-influencer-autostart', 'true');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var revealed = false;

    function reveal() {
      if (revealed) {
        return;
      }

      revealed = true;
      removePoster(video);
    }

    function watchSmooth() {
      if (typeof video.requestVideoFrameCallback !== 'function') {
        reveal();
        return;
      }

      video.requestVideoFrameCallback(function() {
        reveal();
      });
    }

    function playNow() {
      if (video.paused) {
        var attempt = video.play();
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(watchSmooth).catch(function() {});
          return;
        }
      }

      watchSmooth();
    }

    playNow();
    window.setTimeout(reveal, 2500);
  }

  function bindVideoControls(root) {
    root.querySelectorAll('[data-influencer-carousel-card]').forEach(function(card) {
      var video = card.querySelector('video');
      if (!video || card.getAttribute('data-influencer-video-ready') === 'true') {
        return;
      }

      card.setAttribute('data-influencer-video-ready', 'true');
      video.muted = true;

      var play = card.querySelector('[data-influencer-play]');
      var mute = card.querySelector('[data-influencer-mute]');

      function sync() {
        card.classList.toggle('is-playing', !video.paused);
        card.classList.toggle('is-muted', video.muted);

        var mediaName = card.getAttribute('data-influencer-media-name');
        var videoName = mediaName ? mediaName + ' video' : 'video';

        if (play) {
          play.setAttribute('aria-label', (video.paused ? 'Play ' : 'Pause ') + videoName);
        }

        if (mute) {
          mute.setAttribute('aria-label', (video.muted ? 'Unmute ' : 'Mute ') + videoName);
        }
      }

      if (play) {
        play.addEventListener('click', function() {
          if (video.paused) {
            pauseOtherVideos(root, video);
            assignSource(video);
            removePoster(video);
            video.setAttribute('data-influencer-user-play', 'true');
            video.play();
          } else {
            video.pause();
          }
        });
      }

      if (mute) {
        mute.addEventListener('click', function() {
          video.muted = !video.muted;
          sync();
        });
      }

      video.addEventListener('play', function() {
        var card = video.closest('[data-influencer-carousel-card]');
        var userPlay = video.getAttribute('data-influencer-user-play') === 'true';
        video.removeAttribute('data-influencer-user-play');

        if (
          !userPlay &&
          root.getAttribute('data-influencer-handed-off') === 'true' &&
          !desktopQuery.matches &&
          card &&
          card.getAttribute('data-influencer-visible') !== 'true'
        ) {
          video.pause();
          return;
        }

        pauseOtherVideos(root, video);
        sync();
      });
      video.addEventListener('pause', sync);
      sync();
    });
  }

  function init(scope) {
    var rootNode = scope || document;
    var carousels = rootNode.querySelectorAll('[data-influencer-carousel]');

    carousels.forEach(initCarousel);
  }

  function refreshAll() {
    document.querySelectorAll('[data-influencer-carousel]').forEach(updateArrows);
  }

  window.addEventListener('resize', refreshAll);

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', refreshAll);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(refreshAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function(event) {
    var card = event.target.closest('[data-influencer-carousel-card]');
    if (!card) {
      return;
    }

    card.scrollIntoView({ behavior: scrollBehavior(), block: 'nearest', inline: 'start' });
  });
})();
